import { useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { ContentfulClient, ContentfulProvider } from "react-contentful";

import { appRoutes } from "routes";
import { useContentfulPage } from "hooks";
import ContentfulPage from "components/ContentfulPage";
import { useSettings, useRouter, useGtmTrackAutomatically } from "hooks";

const ContentfulWrapper = ({ page, lang, loader }) => {
  const { slug } = useParams();
  const { push, location } = useRouter();
  const contentfulSlug = page || slug;
  const { data, fetched, loading } = useContentfulPage(contentfulSlug, lang);

  useGtmTrackAutomatically();

  useEffect(() => {
    if (!loading && fetched && !data.length) {
      push({ pathname: appRoutes.page404Path(), state: { referrer: location.pathname } });
    }
  }, [loading, fetched, data]);

  if (loading || !fetched || !data.length) {
    return loader || null;
  }

  return (
    <div>
      <ContentfulPage data={data} />
    </div>
  );
};

const Contentful = ({ page, lang, loader }) => {
  const {
    settings: {
      contentful: { accessToken, previewAccessToken, space },
    },
  } = useSettings();
  const {
    camelizedQuery: { contentfulPreview, contentfulEnv },
  } = useRouter();

  const clientAttrs = {
    space,
    environment: import.meta.env.VITE_CONTENTFUL_ENVIRONMENT,
    accessToken,
    ...(contentfulEnv && { environment: contentfulEnv }),
    ...(contentfulPreview &&
      contentfulPreview === "on" && { accessToken: previewAccessToken, host: "//preview.contentful.com" }),
  };

  const contentfulClient = new ContentfulClient(clientAttrs);
  return (
    <ContentfulProvider client={contentfulClient}>
      <ContentfulWrapper page={page} lang={lang} loader={loader} />
    </ContentfulProvider>
  );
};

Contentful.propTypes = {
  page: PropTypes.string,
  lang: PropTypes.string,
  loader: PropTypes.node,
};

ContentfulWrapper.propTypes = {
  page: PropTypes.string,
  lang: PropTypes.string,
  loader: PropTypes.node,
};

export default Contentful;
